// removed by extract-text-webpack-plugin
module.exports = {"fadingBackground":"src-components-commons-FadingBackground-style----general-module---fadingBackground---2Y777 pinFill pointerEvents-none position-fixed"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/FadingBackground/style/general.module.css
// module id = 1424
// module chunks = 168707334958949